export default function useDim() {
  const width = window.innerWidth;
  return width > 600 ? true : false;
}
